export default IconMultiplier2x => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-multiplier-2x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M14 16l4 -4" />
  <path d="M18 16l-4 -4" />
  <path d="M6 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0" />
</svg>`;